import { useAppConfigContext } from "../providers/hooks/AppConfigContext";

const LOGO_SIZE = 50;

export default function Logo() {
  const appConfig = useAppConfigContext();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "calc(100% - 10px)",
        padding: 5,
      }}
    >
      <img src="logo.png" alt="Logo" width={LOGO_SIZE} height={LOGO_SIZE} />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <p
          style={{
            padding: 0,
            margin: 0,
            width: "100%",
            textAlign: "left",
            fontSize: "1.5rem",
            color: "#b83e00dd",
          }}
        >
          <strong>bussola.farm</strong>
        </p>
        <p
          style={{
            padding: 0,
            margin: 0,
            width: "100%",
            textAlign: "center",
            marginLeft: 15,
            color: "#b83e00aa",
          }}
        >
          {appConfig?.name ?? "app"}
        </p>
      </div>
    </div>
  );
}
